import React, { Component } from 'react';
// import countapi from 'countapi-js';
import fetch from 'cross-fetch';

class VisitFunzioni extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  async callAPI() {

    if (window.location.href.includes('mostafamilani.ir/funzioni')) {

      await

        fetch("https://server-mostafamilani.iran.liara.run/record/63d7484b07bd5d81cb468dd9", {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(res => res.text())
          .then(res => this.setState({ apiResponse0: JSON.parse(res).contatore + 1 }));

      fetch("https://server-mostafamilani.iran.liara.run/update/63d7484b07bd5d81cb468dd9", {
        method: "POST",
        body: JSON.stringify({
          contatore: Number(this.state.apiResponse0),
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.text())
        .then(res => this.setState({ apiResponse: res }));


      fetch("https://server-mostafamilani.iran.liara.run/record/63d7484b07bd5d81cb468dd9", {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.text())
        .then(res => this.setState({ apiResponse2: JSON.parse(res).contatore }));

    }

  }

  componentWillMount() {
    this.callAPI();
  }

  render() {

    return (
      <span style={{fontSize: '14px'}} title="Numero delle visite sulla pagina 'Funzioni'">(👁 {this.state.apiResponse2})</span>
    );

  }
}

// class VisitFunzioni extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {

//     };
//   }

//   componentDidMount() {
//     countapi.visits('funzioni').then((result) => {
//       console.log(result)
//       this.setState({ visiteFunzioni: result.value });
//     });
//   }

//   render() {

//     return (
//       <span style={{fontSize: '14px'}} title="Numero delle visite sulla pagina 'Funzioni'">(👁 {this.state.visiteFunzioni})</span>
//     );

//   }
// }

export default VisitFunzioni;